import OrderItem from "@/modules/delivery/core/models/OrderItem";

class OrderPromo {
    constructor({promo, price, items}) {
        this.className = 'OrderPromoModel'
        this._id = this.generateObjectId()
        this.promo = promo
        this.price = price
        this.items = items.map(i => new OrderItem(i))

    }

    generateObjectId() {
        const timestamp = Math.floor(new Date().getTime() / 1000).toString(16);
        const machineIdentifier = Math.floor(Math.random() * 0xFFFFFF).toString(16).padStart(6, '0');
        const processIdentifier = Math.floor(Math.random() * 0xFFFF).toString(16).padStart(4, '0');
        const counter = Math.floor(Math.random() * 0xFFFFFF).toString(16).padStart(6, '0');

        return timestamp + machineIdentifier + processIdentifier + counter;
    }

    isComplete(){
        return this.promo.config.every(c => this.hasReachMaxCategory(c.category))
    }

    getQuantityByCategory(category) {
        let quantity =  this.items
            .filter(i => i.hasCategory(category))
            .reduce((a, v) => a + v.quantity, 0)
        return quantity > 0 ? quantity : 0
    }

    hasReachMaxCategory(category){
        let promoCategory = this.promo.config.find(c => c.category.id === category.id)
        if(promoCategory){
            return promoCategory.quantity <= this.getQuantityByCategory(category)
        }else{
            throw new Error("Promo config not found for category")
        }

    }

    getQuantityByCategoryAndProduct(product, category) {
        let quantity =  this.items
            .filter(i => i.hasProductAndCategory(product, category))
            .reduce((a, v) => a + v.quantity, 0)
        return quantity > 0 ? quantity : null
    }



    addPromoItem(product, category) {

        if(this.hasReachMaxCategory(category)){
            console.log("Max quantity reached for category")
            return
        }

        let item = this.items.find(i => i.hasProductAndCategory(product, category))
        if (item) {
            item.quantity++
        } else {
            this.items.push(new OrderItem({
                        product: product,
                        category: category,
                        quantity: 1,
                    }
                )
            )
        }
    }

    removePromoItem(product, category) {
        let item = this.items.find(i => i.hasProductAndCategory(product, category))
        if (item && item.quantity > 0) {
            item.quantity--
        }

        if (item.quantity === 0) {
            let index = this.items.findIndex(i => i.hasProductAndCategory(product, category))
            this.items.splice(index, 1)
        }
    }

}

export default OrderPromo;
